/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { GeneralContextFunc } from "../Context/GeneralContex";

const YoutubeThumbnail = ({ youtubeLink }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState("");
  const { initAlert } = GeneralContextFunc();
  useEffect(() => {
    let youtubeUrl = youtubeLink;
    let urlId = youtubeUrl.split("youtu.be/")[1];
    console.log("uuu", urlId);
    if (!urlId) {
      initAlert("Invalid youtube link", "info");
      return;
    }
    let videoId = urlId.split("?")[0];
    let thumbnailUrl = `https://img.youtube.com/vi/${videoId}/0.jpg`;
    setThumbnailUrl(thumbnailUrl);
  }, [youtubeLink]);

  return (
    <>
      {thumbnailUrl && (
        <div style={{ marginTop: "16px" }}>
          <img
            alt="thumbnail"
            width="227px"
            height="140px"
            src={thumbnailUrl}
          />
        </div>
      )}
    </>
  );
};

export default YoutubeThumbnail;
